import { PackStatus } from 'app/typings/core/admin/packs/enum/pack';
import {
  PACK_STATUS_DISPLAY_ORDER,
  PACK_STATUS_LABELS,
} from 'app/utils/packStatus';

import type { GroupedHotelPackages, HotelPackage } from '../../_types';

export const getPackageNameForHotel = (pkg: HotelPackage) =>
  pkg.nameForHotel?.trim() !== ''
    ? pkg.nameForHotel?.trim()
    : `Package #${pkg.id}`;

export const getPackageNameForUser = (pkg: HotelPackage) =>
  pkg.nameForUser?.trim() !== '' && pkg.nameForUser !== undefined
    ? pkg.nameForUser?.trim()
    : null;

export const getPackageStatus = (pkg: HotelPackage): PackStatus => {
  if (
    pkg.status === PackStatus.PUBLISHED ||
    pkg.status === PackStatus.SETUP ||
    pkg.status === PackStatus.HIDDEN
  ) {
    return pkg.status;
  }

  return PackStatus.UNPUBLISHED;
};

export const getPackageStatusLabel = (status: PackStatus) =>
  PACK_STATUS_LABELS[status];

export const sortPackagesByStatus = (packages: HotelPackage[]) =>
  [...packages].sort(
    (packageA, packageB) =>
      PACK_STATUS_DISPLAY_ORDER[getPackageStatus(packageA)] -
      PACK_STATUS_DISPLAY_ORDER[getPackageStatus(packageB)]
  );

export const isDaytimePackage = (pkg: HotelPackage) => pkg.isDaytime ?? false;

export const groupPackagesByPeriod = (
  packages: HotelPackage[]
): GroupedHotelPackages => ({
  nightStayPackages: packages.filter((pkg) => !isDaytimePackage(pkg)),
  daytimePackages: packages.filter(isDaytimePackage),
});

export const getPackagePath = (pkg: HotelPackage, isHotelLegacy: boolean) =>
  isHotelLegacy ? `/packs/legacy/${pkg.id}` : `/packs/${pkg.id}`;
